import type { ContextState, FeatureNode, FeaturesTree } from '../../models'
import type { FeatureComposable } from './types'
// @ts-strict-ignore
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { PermissionLevelEnum } from '@empathybroker/tsclient-play/dist/enums/permission-level.enum'
import { computed, getCurrentInstance } from 'vue'
import { FeatureIdEnum } from '../../enums'
import { APP_CONSTS } from '../../store/app/app.consts'
import { CONTEXT_CONSTS } from '../../store/context/context.consts'
import { FeaturesTreeUtils } from '../../utils'
import { mapGetters } from '../utils'

export const useFeature = (): FeatureComposable => {
  const ctx = getCurrentInstance()

  const { featuresTree } = mapGetters<FeaturesTree>(ctx.proxy.$store, APP_CONSTS.moduleName, {
    featuresTree: APP_CONSTS.getters.featuresTree,
  })

  const featureId = computed<FeatureIdEnum | string>(() => ctx.proxy.$route.meta?.featureId)

  const { context } = mapGetters<ContextState>(ctx.proxy.$store, CONTEXT_CONSTS.moduleName, {
    context: CONTEXT_CONSTS.getters.context,
  })

  const featureNode = computed<FeatureNode>(() => {
    if (!featureId.value) {
      return
    }
    return getFeatureNode(featureId.value)
  })

  const section = computed<string>(() => {
    if (featureId.value === FeatureIdEnum.EXPLAIN) {
      return FeatureIdEnum.PLAY
    }
    return getFeatureNode(featureId.value)?.parentId
  })

  const readonly = computed<boolean>(() => {
    return featureNode.value?.permissionLevel !== PermissionLevelEnum.WRITE
  })

  function getFeatureNode(featureId: FeatureIdEnum | string, domain?: DomainEnum): FeatureNode {
    if (!domain) {
      domain = context.value.domain ?? DomainEnum.GLOBAL
    }

    return FeaturesTreeUtils.getFeatureNode(
      featureId,
      featuresTree.value ? featuresTree.value[domain] : undefined,
    )
  }

  return {
    featuresTree,
    featureId,
    featureNode,
    section,
    readonly,
    getFeatureNode,
  }
}

export * from './types'
